import React, { Component } from "react";
import PropTypes from "prop-types";
//import uniqueId from "lodash.uniqueid";

export default class InputField extends Component {
	state = {
		// inputId: uniqueId("react-address-lookup-id-"),
	};
	placeholder() {
		if (this.props.placeholder === false) {
			return "";
		} else if (this.props.placeholder != null) {
			return this.props.placeholder;
		} else {
			return "e.g. NR14 7PZ or 1 Mill Lane London";
		}
	}
	render() {
		return (
			<div className="pr-4 pl-1">
				<label className="address-lookup-label" htmlFor={this.state.inputId}>
					{this.props.labelText}
				</label>
				
				<input
					className="address-lookup-input"
					placeholder={this.placeholder()}
					onChange={this.props.updateInput}
					id={this.props.inputId}
				/>
				
			</div>
		);
	}
}

InputField.defaultProps = {
	labelText: "Enter the Postcode/ Address",
};

InputField.propTypes = {
	placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};
